module.exports = __webpack_public_path__ + "media/img/frontend_application/master_card-d86b43675d4dec260acb6fbb91300559.png";